<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="mandaa"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand">{{ routeName }}</a>
    </div>

    <ul class="navbar-nav ml-auto">
      <base-dropdown
        tag="li"
        title-tag="a"
        class="nav-item text-white"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template slot="title">
          <div class="photo"><i class="tim-icons icon-button-power text-white"></i></div>
          <b class="caret d-none d-lg-block d-xl-block text-white"></b>
          <p class="d-lg-none text-white">{{ $t("auth:logout.text") }}</p>
        </template>
        <li class="nav-link">
          <router-link to="/profile" class="nav-item dropdown-item">{{
            $t("dashboard:navbar.view_profile")
          }}</router-link>
        </li>
        <li class="nav-link">
          <a
            @click.prevent="logout()"
            class="nav-item dropdown-item"
            data-test="logout-button"
            >{{ $t("auth:logout.text") }}</a
          >
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import BaseNav from "./black_dashboard_pro/Navbar/BaseNav";
import HttpClientFactory from "../services/HttpClientFactory";
import SidebarToggleButton from "./black_dashboard_pro/Layout/SidebarToggleButton";
import AuthenticationServiceFactory from "../services/AuthenticationServiceFactory";
import { mapActions } from "vuex";

export default {
  components: {
    SidebarToggleButton,
    BaseNav,
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      const translate = "router:navbar." + name;
      return this.$t(translate);
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  created() {
    this.httpClient = HttpClientFactory.getInstance();
    this.AuthenticationService = AuthenticationServiceFactory.getInstance();
  },
  methods: {
    ...mapActions(["setUser"]),

    logout() {
      this.httpClient
        .post(process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/logout")
        .then(() => {
          this.httpClient.clearToken();
          this.AuthenticationService.clearAuthTokenFromStorage();
          sessionStorage.removeItem("rememberCheck");
          window.location.href = "/login";
        })
        .catch((e) => {
          console.log(e);
        });
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
</style>
